<template>
	<div id="footer">
		<div class="container">
			<div class="footer-1">
				<div class="foo1-1 fl">
					<div class="foo-title" @click="logoIndex()">
						<img src="/images/logo2.png" alt="">
					</div>
					<div class="foo-dl1">
						<dl>
							<dd v-for="(item,index) in linkList1">
								<a :href="item.url" target="_blank">{{item.name}}</a>
							</dd>
						</dl>
						<div class="clear"></div>
					</div>
				</div>
				<div class="foo1-2 fl">
					<div class="foo-title">
						相关链接
					</div>
					<div class="foo-dl1">
						<dl>
							<dd v-for="(item,index) in linkList2">
								<a :href="item.url" target="_blank">{{item.name}}</a>
							</dd>
						</dl>
						<div class="clear"></div>
					</div>
				</div>
				<div class="foo1-3 fr">
					<div class="foo-title">
						联系我们
					</div>
					<div class="foo1-3-div">
						<div class="er fr"><img :src="icoURL+'storage/'+settingObj.wechat" alt=""></div>
						<div class="foo1-3-dl">
							<dl>
								<dd>地址：{{this.settingObj.address}}</dd>
								<dd>电话：{{this.settingObj.tel}}</dd>
								<dd>传真：{{this.settingObj.fax}}</dd>
								<dd>邮箱：{{this.settingObj.email}}</dd>
								<dd>纪检监督举报电话：0913-2150368</dd>
							</dl>
						</div>
						<div class="clear"></div>
					</div>
				</div>
				<div class="clear"></div>
			</div>
			<div class="footer-2">
				版权所有：{{this.settingObj.copyright}} &nbsp 技术支持：<a href="http://www.guifeng.net" target="_blank">硅峰网络</a> &nbsp <a :href="this.settingObj.company_email" target="_blank">公司邮箱</a>&nbsp <a :href="this.settingObj.group_email" target="_blank">集团邮箱</a><br />
				<img src="/images/gh.png" alt="">陕公网安备 61050202000521号 &nbsp {{this.settingObj.icp}}
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'foot',
		data(){
			return{
				linkList1:[],
				linkList2:[],
				setting:{},
				settingObj:{
					copyright:'',
					icp:'',
					address:'',
					tel:'',
					fax:'',
					email:'',
					wechat:'',
					group_email:'',
					company_email:''
				}
			}
		},
		methods:{
			logoIndex(){
				this.$router.push('/');
				$("#nav-2-heidi").fadeOut();
				$(".nav-2>ul>li>ul").slideUp();
				$(".nav-2").slideUp();
				$('html, body').animate({ scrollTop: 0 }, 0);
			},
			res_link(){
				this.axios.get('/api/link?category_id=1439')
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// this.menus = response.data.reslut;
							this.linkList1 = response.data.reslut;
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
				this.axios.get('/api/link?category_id=1440')
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// this.menus = response.data.reslut;
							this.linkList2 = response.data.reslut;
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_setting(){
				this.axios.get('/api/setting')
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// this.menus = response.data.reslut;
							this.setting = response.data.reslut;
							this.setting.forEach(item=>{
								if(item.key == "xsjgw.copyright"){
									this.settingObj.copyright = item.value;
								}
								if(item.key == "xsjgw.icp"){
									this.settingObj.icp = item.value;
								}
								if(item.key == "xsjgw.address"){
									this.settingObj.address = item.value;
								}
								if(item.key == "xsjgw.tel"){
									this.settingObj.tel = item.value;
								}
								if(item.key == "xsjgw.fax"){
									this.settingObj.fax = item.value;
								}
								if(item.key == "xsjgw.email"){
									this.settingObj.email = item.value;
								}
								if(item.key == "xsjgw.wechat"){
									this.settingObj.wechat = item.value;
								}
								if(item.key == "xsjgw.group_email"){
									this.settingObj.group_email = item.value;
								}
								if(item.key == "xsjgw.company_email"){
									this.settingObj.company_email = item.value;
								}
							}) 
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			}
		},
		created() {
			this.res_link();
			this.res_setting();
		}
	}
</script>

<style>
</style>